import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { Contenedores, ContenedorFiltroDTO, ContenedorFiltroView, ESTADO_CONTENEDOR, FechaContenedor, SIGNO_FECHA } from '../../../../core/model/inventories';
import { Page } from '../../../../core/model/page';
import { IPagination } from '../../../../core/model/pagination';
import { AlmacenService } from '../../../../core/services/almacen.service';
import { ShoppingElementsService } from '../../../../core/services/shopping-elements.service';
import { UtilitiesService } from '../../../../core/services/Utility/utilities.service';

@Component({
  selector: 'app-filtros-contenedor',
  templateUrl: './filtros-contenedor.component.html',
  styleUrls: ['./filtros-contenedor.component.css']
})
export class FiltrosContenedorComponent implements OnInit {
  @Input() page: Page;

  @Input() set rechargeRecords(rechargeRecords: boolean) {
    if (rechargeRecords) {
      this.searchContainers();
    }
  }
  @Output() rechargeRecordsChange = new EventEmitter<boolean>();

  @Output() loading = new EventEmitter<boolean>();
  @Output() contenedoresProcesados = new EventEmitter<Contenedores[]>();

  filtro: ContenedorFiltroView = new ContenedorFiltroView();
  enumStates = ESTADO_CONTENEDOR;
  signDates = SIGNO_FECHA;
  stateModel = 'noSelect';

  filtrosDTO: ContenedorFiltroDTO;

  public bsConfig: BsDatepickerConfig;

  constructor(private utilsService: UtilitiesService,
    private almacenService: AlmacenService,
    private shoppingElementsService: ShoppingElementsService) { }

  ngOnInit() {
    this.bsConfig = this.utilsService.getDatepickerConfig();
  }

  setSerie(serie: any) {
    this.filtro.ID_SERIE = parseInt(serie, 10);
    this.contenedoresProcesados.emit([]);
  }

  setClientSelected(event) {
    if (event.cliente === 0) {
      this.filtro.ID_SERIE = undefined;
    }
    this.filtro.ID_CLIENTE = parseInt(event.cliente, 10);
  }

  limpiar() {
    const idSerie = this.filtro.ID_SERIE;
    this.filtro = new ContenedorFiltroView();
    this.filtro.ID_SERIE = idSerie;
  }

  states(): Array<string> {
    const keys = Object.keys(this.enumStates);
    return keys.filter(key => isNaN(parseInt(key, 10)));
  }

  setState(event) {
    const value = event.target.value;
    this.filtro.ESTADO = (value != 'noSelect') ? parseInt(this.enumStates[value], 10)
      : undefined;
  }

  getSignDates() {
    return Object.keys(this.signDates);
  }

  setSign(event, fechaContenedor: FechaContenedor) {
    const enumValue = event.target.value;
    fechaContenedor.signo = this.signDates[enumValue];
  }
  getFiltersDTO(): ContenedorFiltroDTO {
    const filtersDTO = new ContenedorFiltroDTO();
    filtersDTO.Id = this.filtro.Id;
    filtersDTO.NUM_CONTENEDOR = this.filtro.NUM_CONTENEDOR;
    filtersDTO.ESTADO = this.filtro.ESTADO;
    filtersDTO.ID_CLIENTE = this.filtro.ID_CLIENTE;
    filtersDTO.ID_SERIE = this.filtro.ID_SERIE;
    filtersDTO.ORDENACION = this.filtro.ORDENACION;
    filtersDTO.ASC = this.filtro.ASC;
    filtersDTO.FECHA_CREACION = this.filtro.FECHA_CREACION.fecha;
    filtersDTO.sFECHA_CREACION = this.filtro.FECHA_CREACION.fecha ? this.filtro.FECHA_CREACION.signo
      : undefined;
    filtersDTO.FECHA_ENTRADA = this.filtro.FECHA_ENTRADA.fecha;
    filtersDTO.sFECHA_ENTRADA = this.filtro.FECHA_ENTRADA.fecha ? this.filtro.FECHA_ENTRADA.signo
      : undefined;
    filtersDTO.FECHA_ESTADO = this.filtro.FECHA_ESTADO.fecha;
    filtersDTO.sFECHA_ESTADO = this.filtro.FECHA_ESTADO.fecha ? this.filtro.FECHA_ESTADO.signo
      : undefined;

    return filtersDTO;
  }

  searchContainersReset() {
    this.page.pageNumber = 0;
    this.searchContainers();
  }

  searchContainers() {
    this.filtrosDTO = this.getFiltersDTO();

    let inicio = this.page.size * this.page.pageNumber;

    if (inicio != 0 && inicio >= this.page.totalElements) {
      inicio = inicio - this.page.size;
    }

    const fin = inicio + (+this.page.size);

    this.getPaginationRecords(inicio, fin);
  }

  private getPaginationRecords(inicio: number, fin: number) {
    this.loading.emit(true);

    this.almacenService.searchInventarioContenedores(inicio, fin, this.filtrosDTO)
      .subscribe((value: IPagination<Contenedores>) => {
        this.proccesContainers(value);
      });
  }

  private proccesContainers(paginationContenedores: IPagination<Contenedores>) {
    this.page.totalElements = paginationContenedores.totalResults;
    const contenedoresWithShoppingCart = this.shoppingElementsService.getRecordsWithCartInformation(paginationContenedores.dataList);
    this.contenedoresProcesados.emit(contenedoresWithShoppingCart);
    this.loading.emit(false);
    this.rechargeRecordsChange.emit(false);
  }

}
